<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2022-10-26 15:42:30
 * @LastEditors: pj
 * @LastEditTime: 2022-10-28 11:03:27
-->
<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
        <a-form-item label="关键字">
            <a-input v-model="searchP.keyword" placeholder="编码/名称"></a-input>
        </a-form-item>
        <a-form-item label="选择模块">
            <a-select default-value="" @change="handleChange">
                <a-select-option value="">
                    全部
                </a-select-option>
                <a-select-option value="mcms">
                    消息中心
                </a-select-option>
                <a-select-option value="ums">
                    账号中心
                </a-select-option>
                <a-select-option value="fms">
                    导入导出
                </a-select-option>
                <a-select-option value="config">
                    云端配置
                </a-select-option>
                <a-select-option value="oss">
                    OSS
                </a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
        </a-form-item>
    </a-form>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            form: this.$form.createForm(this),
            searchP: {
                keyword: '',
                module: '',
            },
        }
    },
    methods: {
        handleSubmit() {
            this.$emit('handleSearch', this.searchP)
        },
        handleChange(value) {
            this.searchP.module = value
            this.$emit('handleSearch', this.searchP)
        },
    },
    mounted() {
        this.handleSubmit()
    },
}
</script>

<style>
.myform {
    margin-bottom: 20px;
}
</style>

